import { Form } from 'react-bootstrap'
import { useTranslation } from 'react-i18next'
import { TimelineSicknessAndRehabilitation } from '../../../../common/icons'
import CustomSwitch from '../../../../common/Switch'
import styles from './SickLeave.module.css'

export const SickLeave = ({ settings, onSettingChange, isSaving }) => {
  const { t } = useTranslation()

  return (
    <div className={styles.container}>
      <div className={styles.sectionHeader}>
        <div className={styles.iconContainer}>
          <TimelineSicknessAndRehabilitation />
        </div>
        <label className={styles.sectionTitle}>{t('SickLeave')}</label>
      </div>

      <Form>
        <Form.Group className="mb-1">
          <div className={styles.switchGroup}>
            <CustomSwitch
              id="selfCertificationEnabled"
              label={t('SelfCertificationEnabled')}
              checked={settings?.selfCertificationEnabled || false}
              onChange={(e) => onSettingChange('selfCertificationEnabled', e.target.checked)}
              disabled={isSaving}
              className="mb-2"
              fixedWidth
              labelPosition="left"
            />
          </div>
        </Form.Group>


        <Form.Group className="mb-3">
          <div className={styles.switchGroup}>
            <CustomSwitch
              id="icdCodeRequired"
              label={t('IcdCodeRequired')}
              checked={settings?.icdCodeRequired || false}
              onChange={(e) => onSettingChange('icdCodeRequired', e.target.checked)}
              disabled={isSaving}
              className="mb-1"
              fixedWidth
              labelPosition="left"
            />
          </div>
        </Form.Group>
      </Form>
    </div>
  )
}
